import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

export class ConstantsUrl {

    // public static BASE_URL = environment.BASE_URL;
    // public static BASE_URL_PROCTOR = environment.BASE_URL_PROCTOR;
    // public static BASE_URL_SCHEDULER = environment.BASE_URL_SCHEDULER;
    // public static API_CRM = environment.API_CRM;
    // public static MICRO_SERVICE_URL = environment.MICRO_SERVICE_URL;
    // public static SCHEDULER_URL = environment.SCHEDULER_URL;

        //-- ProdAPI
       public static BASE_URL = "https://valhallamasterapi.provexam.com/";
       public static BASE_URL_PROCTOR = "https://proctorconsoleapi.provexam.com/";
       public static BASE_URL_SCHEDULER = "https://schedulerapi.provexam.com/";
       public static API_CRM = "https://valhallacrmapi.provexam.com/";
       public static MICRO_SERVICE_URL = "https://proctorconsolemicroservice.provexam.com";
       public static SCHEDULER_URL = "https://scheduler.provexam.com/";
       public static REVIEWERCONSOLE_API = "https://reviewerconsoleapi.provexam.com/";
       public static SECURE_SEARCH_SECUGEN_API="https://secugenapi.provexam.com";
       public static Reason_For_No_Show_api ='https://schedulermicroservice.provexam.com/'

// FP License Key  Prod Env
      public static SECUGEN_LIC="4xohaUd04ZeSbtuxhm0QRZZ4n98pBivEAD+7qTD5aGg0oc2n/5PngYdT0wR5n+Ll";
    


    //-- TestAPI
    //     public static BASE_URL = "https://testvalhallamasterapi.examroom.ai:4433/";
    //     public static BASE_URL_PROCTOR = "https://testvalhallaproctorconsoleapi.examroom.ai:4438/";    
    //     public static BASE_URL_SCHEDULER = "https://testvalhallaschedulerapi.examroom.ai:4439/";
    //     public static API_CRM = "https://testvalhallacrmapi.examroom.ai:4431/";
    //     public static MICRO_SERVICE_URL = "https://testproctorconsolemicroservice.examroom.ai:4434";
    //     public static SCHEDULER_URL = "https://testschedulerui.examroom.ai:4444/";
    //     public static REVIEWERCONSOLE_API ="https://testvalhallareviewerapi.examroom.ai:4432/";
    //     public static SECURE_SEARCH_SECUGEN_API="https://testfingerprint.examroom.ai:4452";
    //     public static Reason_For_No_Show_api ='https://testschedulermicroservice.examroom.ai:4435/'
    //  //FP License Key  Test Env
    //   public static SECUGEN_LIC="7LH6C+YbU64Pvk5Ob0r1gJz3l8B2DBvZiOXj+dc7I386oSvhv3sGm2oUikqZJIo+";

    
     public static SECUGENAPI_URL="https://localhost:8443/";

     //--Local APIS
     //public static MICRO_SERVICE_URL = "https://localhost:44366";
     // public static REVIEWERCONSOLE_API ="http://localhost:53913/";


   // ------------------
    public static drupalUrl: string = "/api/1/drupal";
    public static version: string = "/api/1/";
    public static PAGES_SCHEDULER = "#/pages/scheduler";
    public static TOKEN_AUTHENTICATION = "/api/1.0/User/TokenAuthentication?";
    public static EXAM_TESTINGSITE = "api/examtestingsite";
    public static EXAM_TESTINGSITE_V1 = "/api/1.0/User/TestingSite";
    public static PROCTOR_SCHEDULE = "api/proctorschedule";
    public static USER_SETTINGS = "api/usersettings";
    public static TEST_TAKER = "api/testtaker";
    // public static TEST_TAKER = "api/1/testtaker";
    public static CANDIDATE_SCHEDULER = "api/candidateschduler";
    public static TEST_SESSION = "api/examtestsession";
    public static TEST_SESSION_PC = "api/pc/examtestsession";
    public static TEST_SESSION_PACKAGE = "api/examtestsessionpackage";
    public static EXAM_TESTINGSITE_USERSEX = "api/examtestingsiteusersex";
    public static PC_DRUPAL = "api/pc/drupal";
    public static CANDIDATE_DOCUMENT = "api/examTestCandidateDocument";
    // public static CANDIDATE_DOCUMENT = "api/1/ExamTestCandidateDocument/CreateExamCandidateDocument";
    public static GET_TEST_TEKER_V1 = "api/testtaker/GetTestTakerV1";
    public static PROCTOR_NOTES = "api/pc/ProctorNote";
    public static UPDATE_NO_SHOW = "api/PC/UpdateNoShow";
    public static GET_AVAILABLE_SCHEDULE_DATE = "api/PC/GetAvailableScheduleDate";
    public static CHANGE_TEST_SESSION_STATUS = "api/valhalla/ChangeTestSessionStatus";
    public static ACCESS_CODE_UPDATE = "api/examtestingsiteusersex/accesscodeupdate";
    public static Resume_Exam_Session ='api/1/OnTestResume'
    public static GET_TEST_PACKAGE_DOCUMENTS = "api/TC/GetTestPackageDocuments";
    public static GET_TOKEN = "api/Dev/OauthToken";
    public static EXAM_TEST_SESSION = "api/examtestsession";
    public static RestrictedCandidate ='/api/1/ExamTestSession/restrictCandidate'
    public static CREATE_TEST_SESSION_BY_ID = "api/arkiv/CreateTestSessionByID";
    public static RECACHE_TEST_PACKAGE = "api/TC/RecacheTestPackage";
    public static SYNC_EXAM_KEY = "api/TC/SyncExamKey";
    public static ERROR_LOGS = "api/Dev/TS_ErrorLogs";
    public static PENDING_SCORE = '/api/1.0/PendingScoring';
    public static RECENTCANDIDATE_PHOTO ='api/examTestCandidateDocument/GetRecentCandidatePhoto'
    static BASE_URL2: string;
    static PROCTOR_API: string;
    public static CHANGE_SESSION_STATUS = "api/valhalla/ChangeTestSessionStatus";
    //Extension
    public static DISABLE_EXTENSION = "api/1.0/OnExtensionDisableRequest";
    public static ENABLE_EXTENSION = "api/1.0/OnExtensionEnableRequest";
    public static CAPTURE_FPLOG="/api/1/FingerPrint/CaptureFingerprintLogs"
    public static NotificationHub: string = "NotificationHub";
     public static GetCandidateTestsessions: string ="/api/1/FingerPrint/GetCandidateTestsessions";
     public static Get_No_Reason_For_No_show :string ='api/1/ExamTestSession/GetAllNoShowReasons'
}

export let httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
}